/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: nJ1Nn58LcfAm7wemZm71QH
// Component: hophp8l6gJc0
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import "./plasmic.css"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/projectcss
import sty from "./PlasmicButtonActionPictogram.module.css"; // plasmic-import: hophp8l6gJc0/css
import image9ARcsVGaJAiQd from "./images/image9.svg"; // plasmic-import: ARcsVGaJAiQD/picture

createPlasmicElementProxy;

export const PlasmicButtonActionPictogram__VariantProps = new Array(
  "size",
  "color",
  "status",
  "shape",
  "iconColor"
);

export const PlasmicButtonActionPictogram__ArgProps = new Array(
  "onClick",
  "pictogram"
);

const $$ = {};

function PlasmicButtonActionPictogram__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          pictogram: {
            src: image9ARcsVGaJAiQd,
            fullWidth: 20,
            fullHeight: 20,
            aspectRatio: undefined
          }
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "size",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.size
      },
      {
        path: "color",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.color
      },
      {
        path: "status",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.status
      },
      {
        path: "shape",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.shape
      },
      {
        path: "iconColor",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.iconColor
      }
    ],

    [$props, $ctx, $refs]
  );
  const currentUser = useCurrentUser?.() || {};
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <button
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "button",
        "button__nJ1Nn",
        "root_reset_nJ1Nn58LcfAm7wemZm71QH",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootcolor_brand]: hasVariant($state, "color", "brand"),
          [sty.rootcolor_distructive]: hasVariant(
            $state,
            "color",
            "distructive"
          ),
          [sty.rootcolor_greyOne]: hasVariant($state, "color", "greyOne"),
          [sty.rootcolor_greyTwo]: hasVariant($state, "color", "greyTwo"),
          [sty.rootcolor_transparentBg]: hasVariant(
            $state,
            "color",
            "transparentBg"
          ),
          [sty.rootcolor_white]: hasVariant($state, "color", "white"),
          [sty.rooticonColor_secondary]: hasVariant(
            $state,
            "iconColor",
            "secondary"
          ),
          [sty.rootshape_full]: hasVariant($state, "shape", "full"),
          [sty.rootsize_large]: hasVariant($state, "size", "large"),
          [sty.rootsize_medium]: hasVariant($state, "size", "medium"),
          [sty.rootsize_small]: hasVariant($state, "size", "small"),
          [sty.rootstatus_disabled]: hasVariant($state, "status", "disabled"),
          [sty.rootstatus_disabled_color_transparentBg]:
            hasVariant($state, "status", "disabled") &&
            hasVariant($state, "color", "transparentBg")
        }
      )}
      onClick={async event => {
        const $steps = {};
        $steps["runOnClick"] = true
          ? (() => {
              const actionArgs = { eventRef: $props["onClick"] };
              return (({ eventRef, args }) => {
                return eventRef?.(...(args ?? []));
              })?.apply(null, [actionArgs]);
            })()
          : undefined;
        if (
          $steps["runOnClick"] != null &&
          typeof $steps["runOnClick"] === "object" &&
          typeof $steps["runOnClick"].then === "function"
        ) {
          $steps["runOnClick"] = await $steps["runOnClick"];
        }
      }}
      type={"button"}
    >
      <PlasmicImg__
        data-plasmic-name={"img"}
        data-plasmic-override={overrides.img}
        alt={""}
        className={classNames(sty.img, {
          [sty.imgiconColor_secondary]: hasVariant(
            $state,
            "iconColor",
            "secondary"
          ),
          [sty.imgsize_large]: hasVariant($state, "size", "large"),
          [sty.imgsize_medium]: hasVariant($state, "size", "medium"),
          [sty.imgsize_small]: hasVariant($state, "size", "small")
        })}
        displayHeight={"auto"}
        displayMaxHeight={"none"}
        displayMaxWidth={"100%"}
        displayMinHeight={"0"}
        displayMinWidth={"0"}
        displayWidth={
          hasVariant($state, "size", "large")
            ? "20px"
            : hasVariant($state, "size", "medium")
              ? "16px"
              : hasVariant($state, "size", "small")
                ? "12px"
                : "10px"
        }
        loading={"lazy"}
        src={(() => {
          try {
            return $props.pictogram;
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return undefined;
            }
            throw e;
          }
        })()}
      />
    </button>
  );
}

const PlasmicDescendants = {
  root: ["root", "img"],
  img: ["img"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicButtonActionPictogram__ArgProps,
          internalVariantPropNames: PlasmicButtonActionPictogram__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicButtonActionPictogram__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicButtonActionPictogram";
  } else {
    func.displayName = `PlasmicButtonActionPictogram.${nodeName}`;
  }
  return func;
}

export const PlasmicButtonActionPictogram = Object.assign(
  // Top-level PlasmicButtonActionPictogram renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    img: makeNodeComponent("img"),
    // Metadata about props expected for PlasmicButtonActionPictogram
    internalVariantProps: PlasmicButtonActionPictogram__VariantProps,
    internalArgProps: PlasmicButtonActionPictogram__ArgProps
  }
);

export default PlasmicButtonActionPictogram;
/* prettier-ignore-end */
